import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(profileOnEnterSaga);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { select, call } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { userProfile } from 'redux/saga/entities/bound';
import { memberStatus } from 'enums/memberStatus';
export function profileOnEnterSaga(client, nextState, replaceState) {
  var profile, status;
  return regeneratorRuntime.wrap(function profileOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(isLoggedIn);

        case 2:
          if (!_context.sent) {
            _context.next = 18;
            break;
          }

          _context.next = 5;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 5:
          profile = _context.sent;
          status = profile.membership.status;

          if (!(status === memberStatus('CANCELLED'))) {
            _context.next = 13;
            break;
          }

          _context.next = 10;
          return call(replaceState, '/rejoin');

        case 10:
          return _context.abrupt("return", _context.sent);

        case 13:
          if (!(status === memberStatus('UNSUBSCRIBED'))) {
            _context.next = 17;
            break;
          }

          _context.next = 16;
          return call(replaceState, '/signup/continue');

        case 16:
          return _context.abrupt("return", _context.sent);

        case 17:
          return _context.abrupt("return");

        case 18:
          _context.next = 20;
          return call(replaceState, "/login".concat(nextState.location.pathname));

        case 20:
          return _context.abrupt("return", _context.sent);

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}